export interface PlatformMeta {
  label: string;
  color: string;
  shortLabel: string;
}

export const PLATFORM_META: Record<string, PlatformMeta> = {
  instagram_feed: {
    label: "Instagram Feed",
    color: "#E1306C",
    shortLabel: "IG Feed",
  },
  instagram_story: {
    label: "Instagram Story",
    color: "#F77737",
    shortLabel: "IG Story",
  },
  linkedin: {
    label: "LinkedIn",
    color: "#0A66C2",
    shortLabel: "LinkedIn",
  },
  twitter: {
    label: "X (Twitter)",
    color: "#1DA1F2",
    shortLabel: "X",
  },
  facebook: {
    label: "Facebook",
    color: "#1877F2",
    shortLabel: "Facebook",
  },
};

export function getPlatformMeta(platform: string): PlatformMeta {
  return (
    PLATFORM_META[platform] ?? {
      label: platform,
      color: "#6B7280",
      shortLabel: platform,
    }
  );
}
